<template>
	<v-header title="待付款订单" headerLeftStatus="true" />
	<div class="sysMain">
		<div class="sysMainBody" v-show="orderList.length>0">
			<Card style=" margin-bottom: 15px;" v-for=" item in orderList">
				<template #title>
					{{converterEx.toDateTimeString(item.order.createAtDate)}}
				</template>
				<template #extra>
					<a href="#" @click.prevent="del(item.order.id)" style="color: red;">
						<Icon type="md-trash"></Icon>
						移除
					</a>
				</template>
				<div style=" border-bottom: 1px dashed #E8EAEC; margin-bottom:5px; padding-bottom: 5px;"
					v-for=" orderDetail in item.orderDetailList">
					<Row>
						<Col span="18" style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap;"><b
							style=" font-size:15px;">{{orderDetail.suiteName}}</b></Col>
						<Col span="6" style=" text-align: right; ">
						<Text type="danger">
							<Numeral :value="orderDetail.unitPrice" format="0,0.00">
								<template #prefix>
									<strong>¥</strong>
								</template>
							</Numeral>
						</Text>
						</Col>
					</Row>
					<Row>
						<Col flex="auto" style="color: #8C8C8C;">{{orderDetail.patientName}}</Col>
						<Col flex="70px" style=" text-align: right; ">
						<a href="#"
							@click.prevent="detailExamFee(orderDetail.unitPrice, orderDetail.suiteName,orderDetail.suiteId)">
							<Icon type="ios-loop-strong"></Icon>
							详情
						</a>
						</Col>
					</Row>
				</div>
				<Row justify="center" align="middle">
					<Col flex="auto" style="font-weight: bold;padding-right: 5px; text-align: right; ">合计<Text
						type="danger" style="padding-right: 10px;">
						<Numeral :value="item.order.amount" format="0,0.00">
							<template #prefix>
								<strong>¥</strong>
							</template>
						</Numeral>
					</Text></Col>
					<Col flex="70px" style="padding-left: 5px;">
						请到现场签到后付款
					<!--	<Button type="primary" @click="pay(item.order.id)">付款</Button>-->
					</Col>
				</Row>
			</Card>
			<Drawer :title="view.orderTitle" placement="bottom" :mask-closable="false" height="80%"
				v-model="view.showExamFeeItem">
				<div style="margin-bottom: 50px;" class="smallfont">
					<Row class="ivu-text-center ivu-b" style="background-color: #FAFAFA;height: 30px;line-height:30px">
						<Col span="24">收费项目</Col>
					</Row>
					<Row class=" ivu-bb ivu-text-center" v-for="item in suiteDetailList"
						style="height: 30px;line-height:30px">
						<Col span="18" class="ivu-br ivu-bl" style="text-align: left;padding-left: 5px;">
						{{item.examFeeItem.examFeeItemName}}</Col>
						<Col span="6" class="ivu-br" style="color: red;text-align: right; padding-right: 5px; ">
						<Numeral :value="item.examFeeItem.unitPrice" format="0,0.00">
							<template #prefix>
								<strong>¥</strong>
							</template>
						</Numeral>
						</Col>
					</Row>
					<Row class=" ivu-bb ivu-text-center" style="height: 30px;line-height:30px">
						<Col span="18" class="ivu-br ivu-bl" style="text-align: left;padding-left: 5px;">合计</Col>
						<Col span="6" class="ivu-br" style="color: red;text-align: right; padding-right: 5px; ">
						<Numeral :value="view.orderDetailUnitPrice" format="0,0.00">
							<template #prefix>
								<strong>¥</strong>
							</template>
						</Numeral>
						</Col>
					</Row>
				</div>
				<FooterToolbar>
					<Button type="warning" @click="view.showExamFeeItem=false">关闭</Button>
				</FooterToolbar>
			</Drawer>
		</div>
		<div style="text-align:center" v-show="view.initComplete===true&&orderList.length===0">
			<Result type="warning" title="" desc="没有相关数据"></Result>
		</div>
	</div>
</template>
<script>
	import header from "@/components/header/index";
	import {
		sysPost,
		sysPostWx
	} from '@/utils/api'

	export default {
		name: 'order',
		data() {
			return {
				view: {
					showExamFeeItem: false,
					orderDetailUnitPrice: 0,
					orderTitle: '',
					spinShow: false,
					initComplete: false,
				},
				orderList: [], //订单列表
				suiteDetailList: [], //体检套餐项目列表
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				var that = this;
				sysPost(that, {
					"url": 'Order/List',
					"data": {
						"State": "待付款"
					}
				}, function(result) {
					that.view.initComplete = true;
					that.orderList = result;
				});
			},
			detailExamFee(orderDetailUnitPrice, suiteName, suiteId) {
				var that = this;
				that.view.orderTitle = suiteName;
				that.view.orderDetailUnitPrice = orderDetailUnitPrice;
				sysPost(that, {
					"url": 'ExamItem/SuiteDetailList',
					"data": {
						SuiteId: suiteId
					}
				}, function(result) {
					that.suiteDetailList = result;
					that.view.showExamFeeItem = true;
				});
			},
			del(orderId) {
				var that = this;
				this.$Modal.confirm({
					title: '友情提示',
					content: '<p>您确认删除?</p>',
					onOk: () => {
						sysPost(that, {
							"url": 'Order/Delete',
							"data": {
								"OrderId": orderId
							}
						}, function(result) {
							that.$Message.success('删除成功！');
							that.getList();
						});
					}
				});
			},
			pay(orderId) {
				var that = this;
				that.$Message.error('请到现场签到后付款！');
				return;
				sysPost(that, {
					"url": 'Pay/PayAdd',
					"data": {
						"OrderId": orderId
					}
				}, function(result) {
					console.log('PayAdd',result);
					that.payPost(result.payUrl);
				});
			},
			payPost(payURL) {
				var that = this;
				if (typeof WeixinJSBridge !== 'undefined') {
					window.location.href = payURL;
					that.$root.spinShow = true;
				} else this.$Message.error('非微信浏览器!');
			}
		},
		components: {
			"v-header": header
		}
	}
</script>